import { InfoModal } from "@newsela/angelou";

import { VIEW_PAGE_LUNA_AI_DESIGN } from "@/ai/constants/experiments";
import AILunaTag from "@/components/AIComponents/AILunaTag/AILunaTag";
import useHasFeature from "@/features/useHasFeature";
import {
  modalContentWrapperCss,
  modalRootCss,
  scrollableBodyCss,
} from "./ExportablesModal.styles";
import ExportablesModalBody from "./ExportablesModalBody";
import { useExportablesModalContext } from "./ExportablesModalContext/useExportablesModalContext";
import ExportablesModalFooter from "./ExportablesModalFooter";

interface ExportablesBaseModalProps {
  isStudent: boolean;
}

const ExportablesBaseModal = ({ isStudent }: ExportablesBaseModalProps) => {
  const {
    handleModalClose,
    isInAssignGraphicOrganizersExperiment,
    isLoading,
    modalProps,
  } = useExportablesModalContext();

  const [showLunaAiBranding] = useHasFeature(VIEW_PAGE_LUNA_AI_DESIGN);

  const modalTitle =
    isStudent || isInAssignGraphicOrganizersExperiment
      ? "Graphic organizers"
      : "Generate graphic organizers";

  return (
    <InfoModal
      __cssFor={{
        root: modalRootCss,
        modalContentWrapper: modalContentWrapperCss,
        scrollableBody: scrollableBodyCss(isStudent),
      }}
      closeButtonProps={{
        dataProps: { "data-qa-selector": "close-exportables-modal-button" },
        onClick: handleModalClose,
      }}
      eyebrow={
        !isStudent && (showLunaAiBranding ? <AILunaTag /> : "Newsela AI Tools")
      }
      isMobileTakeover
      labelId="exportables-modal"
      onBackgroundClick={handleModalClose}
      title={modalTitle}
      footer={!isLoading && <ExportablesModalFooter isStudent={isStudent} />}
      {...modalProps}
    >
      <ExportablesModalBody isStudent={isStudent} />
    </InfoModal>
  );
};

export default ExportablesBaseModal;
